import type Keycloak from 'keycloak-js';
import type { KeycloakAdapter, KeycloakLoginOptions, KeycloakLogoutOptions, KeycloakRegisterOptions } from 'keycloak-js';
import type { ExtendedKeycloakInstance } from '../keycloak-js';
import { log } from '../log';

export class WebAdapter implements KeycloakAdapter {

  private keycloak: ExtendedKeycloakInstance;

  constructor(
    keycloak: Keycloak,
  ) {
    log.trace('Instantiating Keycloak Web adapter.', keycloak);
    this.keycloak = keycloak as ExtendedKeycloakInstance;
  }

  login(options?: KeycloakLoginOptions): Promise<void> {
    window.location.replace(this.keycloak.createLoginUrl(options));
    return this.keycloak.createPromise().promise;
  }

  logout(options?: KeycloakLogoutOptions): Promise<void> {
    const promise = this.keycloak.onAuthLogout?.() ?? Promise.resolve();
    promise.then(() => window.location.replace(this.keycloak.createLogoutUrl(options)));

    return this.keycloak.createPromise().promise;
  }

  register(options?: KeycloakRegisterOptions): Promise<void> {
    window.location.replace(this.keycloak.createRegisterUrl(options));
    return this.keycloak.createPromise().promise;
  }

  accountManagement(): Promise<void> {
    const accountUrl = this.keycloak.createAccountUrl();
    if (typeof accountUrl !== 'undefined') {
      window.location.href = accountUrl;
    } else {
      throw new Error('Not supported by the OIDC server');
    }
    return this.keycloak.createPromise().promise;
  }

  redirectUri(options: { redirectUri: string }, encodeHash = true): string {
    if (options?.redirectUri) {
      return options.redirectUri;
    } else if (this.keycloak.redirectUri) {
      return this.keycloak.redirectUri;
    } else {
      return window.location.href;
    }
  }
}
